module.exports = __webpack_public_path__ + "img/bg_m.c2c12592.jpg";